import request from './request';
import config from '../config'

export const domain = ()=>{
    return config.base_url;
}

export const get = (url,data=[])=>{
    return new Promise((resolve, reject)=>{
        request.get(url,{
            params: data
        }).then(res=>{
            resolve(res);
        }).catch(error=>{
            reject(error);
        });
    });
}

export const post = (url,data=[])=>{
    return new Promise((resolve, reject)=>{
        request.post(url,data).then(res=>{
            resolve(res);
        }).catch(error=>{
            reject(error);
        });
    });
}

export const download = (url,data=[])=>{
    return new Promise((resolve, reject)=>{
        request.request({
            url: url,
            method: "post",
            data: data,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            responseType: "blob",
        }).then((res) => {
            resolve(res);
        }).catch(error=>{
            reject(error);
        });
    });
}